import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseFormControl } from '../base-control';
import { FormCountrySelectField } from '../form-field';
import { COUNTRY_OPTIONS, getCountryName } from './countries';

@Component({
    standalone: false,
    selector: 'abs-country-select',
    template: `
        <div *ngIf="parentFormGroup" [formGroup]="parentFormGroup">
            <div class="form-group">
                <label *ngIf="!field.hideLabel">
                    {{ field.label || (field.name | formLabel)
                    }}<span class="required-marker" *ngIf="field.required" aria-hidden="true">*</span>
                    <ion-icon class="info" *ngIf="field.description" name="information-circle" (click)="showDescription($event)"></ion-icon>
                </label>
                <ion-input
                    type="text"
                    [value]="inputDisplayValue"
                    (ionInput)="onTyping($event)"
                    [placeholder]="'Type to search...'"
                    absAutoComplete
                    [options]="countryOptions"
                    (commitSelection)="onSelect($event)"
                    (selectionUpdate)="onHighlight($event)"
                ></ion-input>
            </div>
        </div>
    `
})
export class CountrySelectComponent extends BaseFormControl implements OnInit, OnDestroy {
    @Input()
    field: FormCountrySelectField;

    readonly countryOptions = COUNTRY_OPTIONS;

    inputDisplayValue = '';
    private readonly destroy$ = new Subject<void>();

    override ngOnInit() {
        super.ngOnInit();
        const code = this.formControl?.value;
        this.inputDisplayValue = code ? getCountryName(code) : '';
        this.formControl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((code) => {
            this.inputDisplayValue = code ? getCountryName(code) : '';
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get formControl(): UntypedFormControl {
        return this.parentFormGroup.controls[this.field.name] as UntypedFormControl;
    }

    onTyping(event: any) {
        const text: string = event.detail.value ?? '';
        if (!text) {
            this.formControl.setValue(null);
        }
    }

    onHighlight(_value: string) {
        // keyboard navigation highlight — no action needed
    }

    onSelect(value: string) {
        this.formControl.setValue(value);
        this.formControl.markAsDirty();
    }
}
